/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 83
// module chunks = 1